// extracted by mini-css-extract-plugin
export default {"container":"Whoami_container__xKf0D","left":"Whoami_left__c2uSw","title":"Whoami_title__wP6zb","right":"Whoami_right__HoIc0","image":"Whoami_image__YuvuP"};